export type ReportLevel = 'state' | 'district' | 'block' | 'village' | 'school';

export interface TableColumn {
  title: string;
  dataIndex: string;
}

export const getTableColumns = (currentLevel: ReportLevel): TableColumn[] => {

  let title = 'State / UT';

  if (currentLevel === 'village') {
    title = 'Village';
  } else if (currentLevel === 'district') {
    title = 'District';
  } else if (currentLevel === 'block') {
    title = 'Block';
  } else if (currentLevel === 'school') {
    title = 'School';
  }

  switch (currentLevel) {
    case 'school':
      return [
        { title: 'S No.', dataIndex: 'serialNo' },
        { title: 'UDISE Code', dataIndex: 'udiseCode' },
        { title: 'School Name', dataIndex: 'schoolName' },
        { title: 'Category', dataIndex: 'category' },
        { title: 'Type', dataIndex: 'type' },
        { title: 'Enrolment', dataIndex: 'enrolment' },
        { title: 'Holiday', dataIndex: 'holiday' },
        { title: 'Reporting Status', dataIndex: 'reportingStatus' },
        { title: 'Meals Served', dataIndex: 'mealsServed' },
      ];
    default:
      return [
        { title: 'S. No.', dataIndex: 'serialNo' },
        { title: title, dataIndex: 'name' },
        { title: 'Total Schools', dataIndex: 'totalSchools' },
        { title: 'Reported', dataIndex: 'schoolsReported' },
        { title: 'Not Reported', dataIndex: 'schoolsNotReported' },
        { title: 'Holiday', dataIndex: 'holiday' },
        { title: 'Meal served (%)', dataIndex: 'mealsServedPct' },
        { title: 'Meal not served %', dataIndex: 'mealsNotServedPct' },
        { title: 'Student Enrolment', dataIndex: 'totalStudents' },
        { title: 'No. of Students approved by PAB', dataIndex: 'mdmEnrolledCount' },
        { title: 'Enrolment', dataIndex: 'reportingSchoolsEnrolment' },
        { title: 'Enrolment %', dataIndex: 'mdmEnrolledPct' },
        { title: 'Availed meals', dataIndex: 'melasServedCount' },
        { title: 'Availed meals %', dataIndex: 'availedMealPct' },
      ];
  }
};
